import { CardForm } from '@components/atoms';
import { FormAddress, FormPersonalData } from '@components/molecules';
import { maskCPF, maskPhone } from '@helpers';
import { Button, Form, Spin } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useEffect } from 'react';

dayjs.extend(utc);

interface FormFamilyEditProps {
	isSubmitting?: boolean;
	isSpouse?: boolean;
	family?: any;
	onFinish?: (values: {
		family: any;
		isSpouseAddress: boolean;
		cep: string;
		street: string;
		number: string;
		complement: string;
		neighborhood: string;
		city: string;
		state: string;
	}) => void;
}

export const FormFamilyEdit = ({
	isSubmitting,
	isSpouse,
	family,
	onFinish,
}: FormFamilyEditProps) => {
	const [form] = Form.useForm();
	const isSpouseAddress = Form.useWatch('isSpouseAddress', form);
	const hasDefaultMemberAddress = Boolean(family?.address && family.isDefaultMember) || Boolean(isSpouse && family?.defaultMemberAddress);

	const onChangeCep = (cep: any) => {
		form.setFieldsValue({
			street: cep.logradouro,
			neighborhood: cep.bairro,
			city: cep.localidade,
			state: cep.uf,
		});
	};

	useEffect(() => {
		form.setFieldsValue(family?.address);
		form.setFieldValue('isSpouseAddress', family?.isSpouseAddress);
		form.setFieldValue('family', {
			...family,
			birthday: family?.birthday && dayjs(family?.birthday).utc(),
			cpf: family?.cpf ? maskCPF(family.cpf) : '',
			phone: family?.phone ? maskPhone(family.phone) : '',
		});
	}, [family, form]);

	return (
		<Spin spinning={isSubmitting}>
			<Form
				layout='vertical'
				size='large'
				className='space-y-6'
				form={form}
				onFinish={onFinish}
				disabled={isSubmitting}
			>
				<CardForm>
					<h3 className='text-lg font-semibold mb-4'>Dados pessoais</h3>
					<FormPersonalData prefix='family' isSpouse={isSpouse} />
				</CardForm>

				<CardForm>
					<h3 className='text-lg font-semibold mb-4'>Endereço</h3>
					<FormAddress onChangeCep={onChangeCep} defaultMemberAddress={hasDefaultMemberAddress} showCopy={isSpouse} />
				</CardForm>

				<div className='px-4 md:px-0 text-right'>
					<Button
						className='w-full md:w-auto'
						type='primary'
						htmlType='submit'
						loading={isSubmitting}
						disabled={isSubmitting || (isSpouseAddress && !hasDefaultMemberAddress)}
					>
						Salvar
					</Button>
				</div>
			</Form>
		</Spin>
	);
};
